export default "__VITE_ASSET__BGk4MSjY__"